module.exports = __webpack_public_path__ + "static/media/undraw_press_play_bx2d.f63c3f30.svg";